/* eslint-disable react/prop-types */
import React from "react";
import { IoArrowRedo } from "react-icons/io5";

import { generateUniqueId } from "../../../utils";

export const CONFIGURATION_COLUMNS = [
  {
    Header: "Name",
    accessor: "attributes.name",
    id: "name",
    disableSortBy: true
  },
  {
    Header: "Status",
    accessor: "attributes.configuration-status-name",
    id: "attributes.configuration-status-name",
    disableSortBy: true
  },
  {
    Header: "Type",
    accessor: "attributes.configuration-type-name",
    id: "attributes.configuration-type-name",
    disableSortBy: true
  },
  {
    Header: "OS",
    accessor: "attributes.operating-system-name",
    id: "attributes.operating-system-name",
    disableSortBy: true
  },
  {
    Header: "Primary IP",
    accessor: "attributes.primary-ip",
    id: "attributes.primary-ip",
    disableSortBy: true
  },
  {
    Header: "Serial Number",
    accessor: "attributes.serial-number",
    id: "attributes.serial-number",
    disableSortBy: true
  },
  {
    Header: "Expires",
    accessor: "attributes.warranty-expires-at",
    id: "attributes.warranty-expires-at",
    disableSortBy: true
  },

  {
    Header: "Location",
    accessor: "attributes.location-name",
    id: "attributes.location-name",
    disableSortBy: true
  },
  {
    Header: "Contact",
    accessor: "attributes.contact-name",
    id: "attributes.contact-name",
    disableSortBy: true
  },
  {
    Header: "",
    accessor: "attributes.resource-url",
    id: "attributes.resource-url",
    maxWidth: 40,
    disableSortBy: true,
    Cell: ({ value }) => (
      <a href={value} target="_blank" rel="noopener noreferrer">
        <IoArrowRedo size="sm" style={{ color: "#50accb" }} />
      </a>
    )
  }
];

export const LICENSING_COLUMNS = [
  {
    Header: "Vendor",
    accessor: "attributes.traits.vendor.values",
    id: "attributes.traits.vendor.values",
    Cell: ({ value }) =>
      value
        ? value.map((item, index) => (
            <div
              key={generateUniqueId()}
            >{`${item.name}${index < value.length - 1 ? "," : ""}`}</div>
          ))
        : null,
    maxWidth: 150,
    disableSortBy: true
  },
  {
    Header: "Manufacturer",
    accessor: "attributes.traits.manufacturer",
    id: "attributes.traits.manufacturer",
    maxWidth: 150,
    disableSortBy: true
  },
  {
    Header: "Name",
    accessor: "attributes.traits.name",
    id: "name",
    maxWidth: 200,
    disableSortBy: true
  },
  {
    Header: "Version",
    accessor: "attributes.traits.version",
    id: "attributes.traits.version",
    maxWidth: 100,
    disableSortBy: true
  },
  {
    Header: "Seats",
    accessor: "attributes.traits.seats",
    id: "attributes.traits.seats",
    maxWidth: 80,
    disableSortBy: true
  },
  {
    Header: "License Key(s)",
    accessor: "attributes.traits.license-key-s",
    id: "attributes.traits.license-key-s",
    Cell: ({ value }) => <div dangerouslySetInnerHTML={{ __html: value }} />,
    disableSortBy: true
  },
  {
    Header: "Purchase Date",
    accessor: "attributes.traits.purchase-date",
    id: "attributes.traits.purchase-date",
    maxWidth: 120,
    disableSortBy: true
  },
  {
    Header: "",
    accessor: "attributes.resource-url",
    id: "attributes.resource-url",
    maxWidth: 40,
    Cell: ({ value }) => (
      <a href={value} target="_blank" rel="noopener noreferrer">
        <IoArrowRedo size="sm" style={{ color: "#50accb" }} />
      </a>
    ),
    disableSortBy: true
  }
];
